import { For } from "solid-js";
import { cn, LIST_COLORS, LIST_ICONS } from "@listto/shared";

interface ColorPickerProps {
  selectedColor: string;
  onSelect: (color: string) => void;
}

export function ColorPicker(props: ColorPickerProps) {
  return (
    <div class="grid grid-cols-6 gap-2">
      <For each={LIST_COLORS}>
        {(color) => (
          <button
            type="button"
            onClick={() => {
              props.onSelect(color.hex);
            }}
            class={cn(
              "h-8 w-8 rounded-full border-2 transition-all hover:scale-110",
              props.selectedColor === color.hex
                ? "border-foreground scale-110"
                : "border-transparent",
            )}
            style={{ "background-color": color.hex }}
            title={color.name}
          />
        )}
      </For>
    </div>
  );
}

interface IconPickerProps {
  selectedIcon: string;
  onSelect: (icon: string) => void;
  color: string;
}

export function IconPicker(props: IconPickerProps) {
  return (
    <div class="flex flex-wrap gap-2">
      <For each={LIST_ICONS}>
        {(icon) => (
          <button
            type="button"
            onClick={() => {
              props.onSelect(icon);
            }}
            class={cn(
              "flex h-10 w-10 items-center justify-center rounded-xl border-2 transition-all hover:bg-accent/10",
              props.selectedIcon === icon ? "border-primary bg-primary/5" : "border-border/50",
            )}
          >
            <span class="text-xl">{icon}</span>
          </button>
        )}
      </For>
    </div>
  );
}
